import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77796dc5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toggle-switch" }
const _hoisted_2 = { class: "toggle-switch-container" }
const _hoisted_3 = ["id", "disabled"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "toggle-switch-slider" }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "toggle-switch-text"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        class: "toggle-switch-checkbox",
        id: _ctx.id,
        tabindex: "0",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.newState) = $event)),
        onChange: _cache[1] || (_cache[1] = $event => (_ctx.changeState())),
        disabled: _ctx.disabled
      }, null, 40, _hoisted_3), [
        [_vModelCheckbox, _ctx.newState]
      ]),
      _hoisted_4,
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.label), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}